module.exports = __webpack_public_path__ + "img/bullhorn.3a20cdee.svg";